<template>

  <div class="container-fluid">
    <div class="row  justify-content-md-center">
      <div class="col-10">
        <h2>Test Configurations</h2>
      </div>
    </div>
    <div>
      <div class="row  justify-content-md-center">
        <div class="col-10">
          <b-table :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :busy.sync="isBusy"
                          :striped="true"
                          :hover="true"
                          :items="fetchConfigs"
                          :fields="listFields"
                          :outlined="true"
                          :small="true"
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          ref="test-config-list-table">
            <template v-slot:cell(version)="data" label="test">
              <router-link :to="{name:'test-config-detail', params:{id:data.item.id}}">{{data.item.version}}</router-link>
            </template>
            <template v-slot:cell(approved_by)="data" label="Approval">
              <a v-if="!data.item.approved_by_name" href="#" @click.prevent.stop="approveTestConfig(data.item.id)">Approve configuration</a>
              <template v-else >Approved by {{data.item.approved_by_name}}</template>
            </template>
          </b-table>
          <div v-if="!device_id" class="row justify-content-md-center">
            <div class="col-6 mt-3">
              <b-pagination size="md" align="center" :total-rows="totalRows" v-model="currentPage" :per-page="perPage"></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import { mapGetters } from 'vuex'

Vue.filter('formatDate', function(value) {
  // console.log(value)
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD HH:mm')
  }
})
export default {
  props: [
    'device_id',
    'filter',
    'released'
  ],
  data () {
    return {
      name: 'test-config-list',
      sortBy: 'id',
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      totalRows: 0,
      listFields:
      [
        { key: 'end_type', label: 'End Type' },
        { key: 'version', label: 'Version' },
        { key: 'created_at', label: 'Created at' },
        'approved_by'
      ]
    }
  },
  computed: {
    ...mapGetters(['hasRole'])
  },
  methods: {
    fetchConfigs() {
      this.isBusy = true
      return this.$http.get(`/test-configuration`).then(response => {
        this.isBusy = false
        return response.data
      }).catch(error => {
        console.log(error)
        // Here we could override the busy state, setting isBusy to false
        this.isBusy = false
        // Returning an empty array, allows table to correctly handle busy state in case of error
        return []
      })
    },
    approveTestConfig(configId) {
      this.$http.put(`/test-configuration`, {
        id: configId,
        approve: true
      }).then(() => {
        this.fetchConfigs()
        this.$refs['test-config-list-table'].refresh()
      })
    }
  }
}
</script>
